import { FC } from 'react';

const Home: FC = () => {
  return <div>Home</div>;
};

export default Home;
